import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import PlantationTableLayer from "../components/PlantationTableLayer";

const PlantationTablePage = () => {
  return (
    <>

      {/* MasterLayout */}
      <MasterLayout>

        {/* Breadcrumb */}
        <Breadcrumb title="All Plantations List" tooltipContent="Add New Complaint" linkTo="/complains/add"  requiredPermission={{ module: 'complaints', action: 'create' }}/>
    
        {/* TableDataLayer */}
        <PlantationTableLayer />

      </MasterLayout>

    </>
  );
};

export default PlantationTablePage; 
